<div class="toggle-switch-container">
    <label class="toggle-switch">
        <input
            type="checkbox"
            [(ngModel)]="value"
            [ngModelOptions]="{ standalone: true }"
        />
        <div>
            <div *ngIf="value; else offIconTemplate">
                <fa-icon [icon]="onIcon"></fa-icon>
            </div>
            <ng-template #offIconTemplate>
                <div>
                    <fa-icon [icon]="offIcon"></fa-icon>
                </div>
            </ng-template>
        </div>
    </label>
    <span class="toggle-label" *ngIf="label">{{ label }}</span>
</div>
